import { CellLayout, Tag, TagColor, Text } from '@equip.health/ui';
import { ReactNode } from 'react';

interface InquiryPlainTextCellProps {
  children: ReactNode | string;
  id: string;
}

const InquiryPlainTextCell = ({ children, id }: InquiryPlainTextCellProps) => {
  return children ? (
    <CellLayout id={id}>
      <Text id={`${id}__plain-text`} overflowX="hidden" textOverflow="ellipsis">
        {children}
      </Text>
    </CellLayout>
  ) : (
    <CellLayout id={id}>
      <Tag color={TagColor.gray} id={id} value="Not set" />
    </CellLayout>
  );
};
export default InquiryPlainTextCell;
